export default __webpack_public_path__ + "static/media/bg-stats-tiles-particles-1.ce0ac3ba.png";